import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { AppService } from './app.service';
import { NgwWowService } from 'ngx-wow';
import { environment } from './../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
// import * as io from 'socket.io-client';
declare const $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // socket = io.connect('https://z.clinicbot.io');

  chatFlag = false;
  chats: any = [];
  title = '';
  logoUrl = '';
  message = '';
  loading = false;
  inputDisabled = false;
  scrolltop = null;
  fontsize = '';
  fontsizeClass = 'medium-txt';
  fontsizeClass2 = 'medium-txt2';
  requestData: any = {
    ip: null,
  };

  /**
   * welcome card & search
  */
  popupFlag = false;
  searchTerm = '';
  homeHeaderData: any = {};
  homechatLinkData: any = {};
  homeCards: any = [];

  subscriptionFlag = false;
  subscriptionUrl = null;
  subscriptionMeta: any = {};
  subscriptionData: any = {};
  subscriptionResp: any = {};

  loginFlag = false;
  loginUrl = null;
  loginMeta: any = {};
  loginData: any = {};
  loginResp: any = {};

  contentSearchFlag = false;
  contentSearchUrl = null;
  contentSearchData: any = {};
  contentSearchResults: any = [];
  contentFormMeta: any = {};
  contentMeta: any = {};

  productSearchFlag = false;
  productSearchUrl = null;
  productSearchData: any = {};
  productSearchResults: any = [];
  productFormMeta: any = {};
  productMeta: any = {};

  searchResultUrl = null;

  homeScroll = null;

  /**
   * calendar
  */
  selectedDate = new Date();
  currentDate = new Date();
  minDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), +1); // one day next before month
  maxDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, +0); // one day before next month

  calendarOptions: any = {
    inline: true,
    firstDay: 0,
    language: 'zh',
    enabledDateRanges: [
      { start: this.minDate, end: this.maxDate }
    ]
  };

  /**
   * drop List
   */

  timerOptions: any = {
    // nav: true,
    // navText: [ '<i class="fa fa-angle-left fa-1g" aria-hidden="true"></i>', '<i class="fa fa-angle-right fa-2x" aria-hidden="true"></i>'],
    loop: false,
    autoWidth: true,
    dots: false,
  };


  /**
   * cards
   */

  cardsOptions: any = {
    nav: true,
    navText: ['<img style="height: 4em;" src=\'assets/image/icon-left.png\'>', '<img style="height: 4em;" src=\'assets/image/icon-right.png\'>'],
    loop: false,
    autoWidth: true,
    dots: false,
    items: 1
  };

  /**
   * persistent menu
  */

  persistantFlag = false;

  persistantMenus: any = [
    { title: 'Home', value: 'home' },
    { title: 'About', value: 'about' },
    { title: 'Contact', value: 'contact' }
  ];

  /**
   * Emoji
  */
  emojiFlag = false;

  /**
   * File upload
  */
  uploadKey = null;
  userID = 'testUser';
  urlData = null;

  color1 = '#333';
  color2 = '#95A5A6';

  @ViewChild('homescrollRef') homescrollRef: ElementRef;
  @ViewChild('chatInput') input: ElementRef;
  @ViewChild('scrollMe') scrollRef: ElementRef;

  constructor(
    private appService: AppService,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private wowService: NgwWowService
  ) {
    // this.socket.on('connect', () => {
    //   console.log('Connected');
    // });
    // this.socket.emit('new message', 'hello');
    // this.socket.on('new message', (data) => {
    //   console.log('Socket', data);
    //   this.responseAnalyser(data, false);
    // });
  }

  ngOnInit() {
    this.initialiseParams();
    this.wowService.init();
    let queryData = window.location.search;
    if ((queryData !== undefined) && (queryData !== null)) {
      if (queryData.charAt(0) === '?') {
        queryData = queryData.substr(1);
        if (queryData.indexOf('=') !== -1) {
          this.urlData = queryData;
        }
      }
    }
    console.log('ok', this.urlData);
  }

  initialiseParams() {
    this.requestData.sessionID = this.getSessionID();
    this.getIPAddress();
    setTimeout(() => {
      const info = this.appService.templateData();
      console.log('info', info);
      this.logoUrl = info.logo;
      this.title = info.title;
      this.uploadKey = info.fileuploadKey;
    }, 200);
  }

  getIPAddress() {
    this.appService.getIP().subscribe(res => {
      this.requestData.ip = res.ip;
      this.getResponse('/init', true);
    }, error => {
      console.log('IPError', error);
    });
  }

  getSessionID() {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 10; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  homeScrollDown() {
    setTimeout(() => {
      if ((this.homescrollRef !== undefined) && (this.homescrollRef !== null)) {
        if ((this.homescrollRef.nativeElement !== undefined) && (this.homescrollRef.nativeElement !== null)) {
          this.homeScroll = this.homescrollRef.nativeElement.scrollHeight;
        }
      }
    }, 200);
  }

  enableChat() {
    this.popupFlag = false;
    this.chatFlag = true;
  }

  showWelcomeScreen() {
    this.popupFlag = false;
    this.chatFlag = false;
  }

  showPopup(searchInfo) {
    this.chatFlag = false;
    if (searchInfo.url !== undefined) {
      this.searchResultUrl = this.sanitizer.bypassSecurityTrustResourceUrl(searchInfo.url);
      this.popupFlag = true;
    }
  }

  hidePopup() {
    this.chatFlag = false;
    this.popupFlag = false;
  }

  contentSearch(searchForm: NgForm) {
    if (searchForm.valid) {
      this.searchResults('content', this.contentSearchUrl, this.contentSearchData);
    }
  }

  productSearch(prodSearchForm: NgForm) {
    if (prodSearchForm.valid) {
      this.searchResults('product', this.productSearchUrl, this.productSearchData);
    }
  }

  searchResults(type, url, data) {
    this.appService.search(url, data).subscribe(res => {
      if (type === 'content') {
        this.contentSearchResults.length = 0;
        setTimeout(() => {
          this.contentSearchResults = res.data;
          this.contentMeta = {
            total: res.total_results,
            offset: res.offset
          };
          if (typeof this.contentMeta.offset === 'number') {
            this.contentSearchData.limit = +(this.contentMeta.offset + 3);
          }
        }, 500);
      } else if (type === 'product') {
        this.productSearchResults.length = 0;
        setTimeout(() => {
          this.productSearchResults = res.data;
          this.productMeta = {
            total: res.total_results,
            offset: res.offset
          };
          if (typeof this.productMeta.offset === 'number') {
            this.productSearchData.limit = +(this.productMeta.offset + 3);
          }
        }, 500);
      }
      // this.homeScrollDown();
    }, error => {
      console.log('searchErr', error);
    });
  }

  dateChanged(event) {
    let selDt = this.datePipe.transform(event, 'MM/dd/yyyy');
    this.message = selDt;
  }

  showDropDown(index) {
    this.chats[index].showDropdown = !(this.chats[index].showDropdown);
  }

  togglePersistancy() {
    this.persistantFlag = !(this.persistantFlag);
  }

  checkForUrl(homeCard) {
    if (homeCard.web_url !== undefined) {
      this.openInNewTab(homeCard.web_url);
    }
  }

  openInNewTab(targetUrl) {
    if (targetUrl !== 'null') {
      if (targetUrl.trim() !== '') {
        window.open(targetUrl, '_blank');
      }
    }
  }

  removeRatingIfExists() {
    const chatLength = this.chats.length - 1;
    if ((this.chats[chatLength]) && (this.chats[chatLength].rating)) {
      this.chats[chatLength].rating = null;
    }
  }

  removeButtonsIfExists() {
    const chatLength = this.chats.length - 1;
    if ((this.chats[chatLength]) && (this.chats[chatLength].buttons) && (this.chats[chatLength].buttons.length)) {
      this.chats[chatLength].buttons.length = 0;
    }
  }

  hideDropDownIfOpened(index) {
    if ((index === null) || (!this.chats[index].showDropdown)) {
      return;
    }
    if (this.chats[index].showDropdown) {
      this.chats[index].showDropdown = false;
    }
  }

  disableDropdownIfExists(index) {
    if ((index === null) || (index === undefined) || (index === 1)) {
      return;
    } else {
      let temp = this.chats[index];
      if (temp.type === 'dropdown') {
        temp.disabled = true;
      }
    }
  }

  onClick(buttonData, index, isDropDown) {
    console.log('Testing', buttonData, index, isDropDown);
    if (buttonData.type && buttonData.type === 'web_url') {
      this.openInNewTab(buttonData.value);
      this.hideDropDownIfOpened(index);
    } else {
      if ((index !== null) && ((this.chats[index].buttons) && (this.chats[index].buttons.length))) {
        this.chats[index].buttons.length = 0;
      } else {
        this.removeRatingIfExists();
        this.removeButtonsIfExists();
        if (isDropDown) {
          if (index !== null) {
            this.chats[index].disabled = true;
            this.hideDropDownIfOpened(index);
          }
        } else {
          this.disableDropdownIfExists(index);
        }
      }

      const chat = {
        isUser: true,
        info: buttonData.title,
        type: 'text',
        text: null
      };
      this.buildResponse(chat, false);

      this.getResponse(buttonData.value, false);
    }
  }

  onSubmit(msgForm: NgForm) {
    if ((this.message !== null) && (this.message !== undefined)) {
      if (msgForm.valid && this.message.trim() !== '') {
        this.removeRatingIfExists();
        this.removeButtonsIfExists();
        this.disableDropdownIfExists(this.chats.length - 1);
        const chat = {
          isUser: true,
          info: this.message,
          type: 'text',
          text: null
        };
        this.buildResponse(chat, false);
        this.getResponse(this.message, false);
      }
      msgForm.resetForm();
    }
  }

  getResponse(queryText, delayFlag) {
    this.persistantFlag = false;
    this.emojiFlag = false;
    this.loading = true;
    if (this.chats.length >= 1) {
      this.chats[this.chats.length - 1].rating = null;
    }
    this.appService.getResponse(this.requestData, queryText.toLowerCase(), this.urlData).subscribe(res => {
      console.log('IPRes', res);
      this.color1 = '#333';
      this.color2 = '#95A5A6';
      this.responseAnalyser(res, delayFlag);
      this.loading = false;
    }, error => {
      this.color1 = '#333';
      this.color2 = '#95A5A6';
      console.log('IPError', error);
      this.loading = false;
    });
  }

  responseAnalyser(res, delayFlag) {
    if ((!res.Speech) || (res.Speech === '') || (res.Speech === null) || (res.Speech === undefined)) {
      this.buildAnswer(null, res.messages, delayFlag);
    } else {
      this.buildAnswer(res.Speech, res.messages, delayFlag);
    }
  }

  buildAnswer(info, mediaData, delayFlag) {
    const text = (info === '') || (info === undefined) ? null : info;
    if ((mediaData !== undefined) && (mediaData.length)) {
      if (mediaData.length === 1) {
        const decisionMaker = mediaData[0];
        if (decisionMaker.welcome !== undefined) {
          this.setUpWelcomeScreenData(decisionMaker.welcome);
        }
        if (decisionMaker.input_disabled !== undefined) {
          this.inputDisabled = decisionMaker.input_disabled;
        } else {
          this.inputDisabled = false;
        }
        this.findMessageType(text, decisionMaker, delayFlag);
      } else if (mediaData.length > 1) {
        mediaData.forEach(element => {
          this.findMessageType(text, element, delayFlag);
        });
      }

    } else if (text !== '') {
      this.inputDisabled = false;
      this.textTemplate(text, null, delayFlag);
    }

  }

  setUpWelcomeScreenData(data) {
    console.log('WelcomeData', data);
    if ((data.header !== undefined) && (data.header !== null)) {
      this.homeHeaderData = data.header;
    }

    if ((data.chat_link !== undefined) && (data.chat_link !== null)) {
      this.homechatLinkData = data.chat_link;
    }

    if ((data.cards !== undefined) && (data.cards !== null)) {
      if (data.cards.length) {
        this.homeCards = data.cards;
      } else {
        this.homeCards = [];
      }
    }

    if ((data.content_search !== undefined) && (data.content_search !== null)) {
      const fields = data.content_search.fields;
      fields.forEach(element => {
        if ((element.type === 'hidden') && (element.name === 'key')) {
          this.contentSearchData.key = element.value;
        }
      });
      this.contentSearchFlag = true;
      this.contentFormMeta = data.content_search;
      this.contentSearchUrl = data.content_search.url;
    }

    if ((data.product_search !== undefined) && (data.product_search !== null)) {
      const fields = data.product_search.fields;
      fields.forEach(element => {
        if ((element.type === 'hidden') && (element.name === 'key')) {
          this.productSearchData.key = element.value;
        }
      });
      this.productSearchFlag = true;
      this.productFormMeta = data.product_search;
      this.productSearchUrl = data.product_search.url;
    }

    if ((data.form_login !== undefined) && (data.form_login !== null)) {
      this.loginFlag = true;
      const fields = data.form_login.fields;
      fields.forEach(element => {
        if ((element.type === 'hidden') && (element.name === 'key')) {
          this.loginData.key = element.value;
        }
      });
      this.loginMeta = data.form_login;
      this.loginUrl = data.form_login.url;
    }


    if ((data.form_subscription !== undefined) && (data.form_subscription !== null)) {
      this.subscriptionFlag = true;
      const fields = data.form_subscription.fields;
      fields.forEach(element => {
        if ((element.type === 'hidden') && (element.name === 'key')) {
          this.subscriptionData.key = element.value;
        }
      });
      this.subscriptionMeta = data.form_subscription;
      this.subscriptionUrl = data.form_subscription.url;
    }
  }

  subscribe(subscribeForm: NgForm) {
    if (subscribeForm.valid) {
      this.appService.subscribe(this.subscriptionUrl, this.subscriptionData).subscribe(res => {
        console.log('subRes', res);
        this.subscriptionResp = res;
        subscribeForm.resetForm();
        if (res.success) {
          setTimeout(() => {
            this.subscriptionFlag = false;
          }, 300);
        }
      }, error => {
        console.log('subErr', error);
      });
    }
  }

  login(loginForm: NgForm) {
    if (loginForm.valid) {
      this.appService.login(this.loginUrl, this.loginData).subscribe(res => {
        this.loginResp = res;
        if (res.success) {
          setTimeout(() => {
            this.loginFlag = false;
          }, 300);
        }
      }, error => {
        console.log('logErr', error);
      });
    }
  }

  findMessageType(text, decisionMaker, delayFlag) {
    console.log(decisionMaker);
    if (decisionMaker.type === 'text') {
      this.textTemplate(text, decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'image') {
      this.imageTemplate(text, decisionMaker, delayFlag);
    } else if ((decisionMaker.type === 'card') && (decisionMaker.card.length)) {
      this.cardTemplate(text, decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'list') {
      this.listTemplate(text, decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'datepicker') {
      this.calendarTemplate(text, decisionMaker.menu, decisionMaker.style, delayFlag);
    } else if (decisionMaker.type === 'quick_replies') {
      this.quickReplyTemplate(text, decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'buttons') {
      this.buttonTemplate(text, decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'cards') {
      this.cardsTemplate(text, decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'droplist') {
      this.dropListTemplate(text, decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'dropdown') {
      this.dropdownTemplate(text, decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'form_comment') {
      this.commentForm1Template(decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'form_comment2') {
      this.commentForm2Template(decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'form_comment3') {
      this.commentForm3Template(decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'form_comment4') {
      this.commentForm4Template(decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'form_comment5') {
      this.commentForm5Template(decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'form_login') {
      this.loginTemplate(decisionMaker, delayFlag);
    } else if (decisionMaker.type === 'form_subscription') {
      this.subscriptionTemplate(decisionMaker, delayFlag);
    }
  }

  textTemplate(info, dm, delayFlag) {
    console.log('Text', dm);
    let temp = null;
    let customStyle = 'pulse';
    let rating = null;
    if ((dm !== undefined) && (dm !== null)) {
      if ((dm.menu !== undefined) && (dm.menu !== null)) {
        if (dm.menu && dm.menu.length) {
          this.persistantMenus = dm.menu;
        }
      }
      if ((dm.rating !== undefined) && (dm.rating !== null)) {
        rating = {
          value: 5,
          id: dm.rating.id,
          type: dm.rating.type
        };
      }

      temp = (dm.text === '') || (dm.text === undefined) ? null : dm.text;
      customStyle = (dm.style === '') || (dm.style === undefined) || (dm.style === null) ? 'pulse' : dm.style;
    }

    const replyMessage = {
      isUser: false,
      info: info,
      type: 'text',
      style: customStyle,
      text: temp,
      rating: rating
    };
    this.buildResponse(replyMessage, delayFlag);
  }

  imageTemplate(info, imageData, delayFlag) {
    let rating = null;
    if ((imageData !== undefined) && (imageData !== null)) {
      if ((imageData.menu !== undefined) && (imageData.menu !== null)) {
        if (imageData.menu && imageData.menu.length) {
          this.persistantMenus = imageData.menu;
        }
      }

      if ((imageData.rating !== undefined) && (imageData.rating !== null)) {
        rating = {
          value: 5,
          id: imageData.rating.id,
          type: imageData.rating.type
        };
      }
    }

    let imageStyle = (imageData.style === '') || (imageData.style === undefined) || (imageData.style === null) ? 'pulse' : imageData.style;
    const imageMessage = {
      isUser: false,
      info: info,
      imageUrl: imageData.image_url,
      webUrl: imageData.web_url,
      type: 'image',
      style: imageStyle,
      rating: rating
    };
    console.log('Ok', imageMessage);
    this.buildResponse(imageMessage, delayFlag);
  }

  quickReplyTemplate(text, data, delayFlag) {
    if ((data.menu !== undefined) && (data.menu !== null)) {
      if (data.menu && data.menu.length) {
        this.setPersistentMenu(data.menu);
      }
    }

    let btnStyle = (data.style === '') || (data.style === undefined) || (data.style === null) ? 'pulse' : data.style;
    const qrMessage = {
      isUser: false,
      info: text,
      type: 'quick_replies',
      text: data.text,
      buttons: data.buttons,
      style: btnStyle
    };
    this.buildResponse(qrMessage, delayFlag);
  }

  buttonTemplate(text, buttonData, delayFlag) {
    if ((buttonData.menu !== undefined) && (buttonData.menu !== null)) {
      if (buttonData.menu && buttonData.menu.length) {
        this.persistantMenus = buttonData.menu;
      }
    }

    let btnStyle = (buttonData.style === '') || (buttonData.style === undefined) || (buttonData.style === null) ? 'pulse' : buttonData.style;
    const buttonMessage = {
      isUser: false,
      info: text,
      type: 'buttons',
      buttons: buttonData.buttons,
      style: btnStyle
    };
    this.buildResponse(buttonMessage, delayFlag);
  }

  listTemplate(text, listData, delayFlag) {
    if ((listData.menu !== undefined) && (listData.menu !== null)) {
      if (listData.menu && listData.menu.length) {
        this.persistantMenus = listData.menu;
      }
    }

    let listStyle = (listData.style === '') || (listData.style === undefined) || (listData.style === null) ? 'pulse' : listData.style;
    const listMessage = {
      isUser: false,
      info: text,
      elements: listData.list.elements,
      button: listData.list.button,
      type: 'list',
      style: listStyle
    };
    this.buildResponse(listMessage, delayFlag);
  }

  cardTemplate(text, cardData, delayFlag) {
    let rating = null;
    if ((cardData !== undefined) && (cardData !== null)) {
      if ((cardData.menu !== undefined) && (cardData.menu !== null)) {
        if (cardData.menu && cardData.menu.length) {
          this.persistantMenus = cardData.menu;
        }
      }

      if ((cardData.rating !== undefined) && (cardData.rating !== null)) {
        rating = {
          value: 5,
          id: cardData.rating.id,
          type: cardData.rating.type
        };
      }
    }

    let cardStyle = (cardData.style === '') || (cardData.style === undefined) || (cardData.style === null) ? 'pulse' : cardData.style;
    const cardMessage = {
      isUser: false,
      card: cardData.card[0],
      info: text,
      type: 'card',
      style: cardStyle,
      rating: rating
    };

    this.buildResponse(cardMessage, delayFlag);
  }

  calendarTemplate(text, menu, style, delayFlag) {
    if ((menu !== undefined) && (menu !== null)) {
      if (menu && menu.length) {
        this.persistantMenus = menu;
      }
    }
    let calendarStyle = (style === '') || (style === undefined) || (style === null) ? 'pulse' : style;
    const calendarMessage = {
      isUser: false,
      type: 'datepicker',
      info: text,
      style: calendarStyle
    };
    this.buildResponse(calendarMessage, delayFlag);
  }

  cardsTemplate(text, cardsData, delayFlag) {
    if ((cardsData.menu !== undefined) && (cardsData.menu !== null)) {
      if (cardsData.menu && cardsData.menu.length) {
        if (cardsData.menu && cardsData.menu.length) {
          this.persistantMenus = cardsData.menu;
        }
      }
    }

    let cardStyle = (cardsData.style === '') || (cardsData.style === undefined) || (cardsData.style === null) ? 'pulse' : cardsData.style;
    const cardsMessage = {
      isUser: false,
      info: text,
      type: 'cards',
      cards: cardsData.cards,
      style: cardStyle
    };

    this.buildResponse(cardsMessage, delayFlag);
  }

  dropdownTemplate(text, dropDownData, delayFlag) {
    if ((dropDownData.menu !== undefined) && (dropDownData.menu !== null)) {
      if (dropDownData.menu && dropDownData.menu.length) {
        this.persistantMenus = dropDownData.menu;
      }
    }

    let customStyle = (dropDownData.style === '') || (dropDownData.style === undefined) || (dropDownData.style === null) ? 'pulse' : dropDownData.style;
    const dropdownMsg = {
      isUser: false,
      info: text,
      type: 'dropdown',
      style: customStyle,
      title: dropDownData.title,
      options: dropDownData.buttons,
      showDropdown: false,
      disabled: false
    };
    this.buildResponse(dropdownMsg, delayFlag);
  }

  dropListTemplate(text, listData, delayFlag) {
    if ((listData.menu !== undefined) && (listData.menu !== null)) {
      if (listData.menu && listData.menu.length) {
        this.persistantMenus = listData.menu;
      }
    }
    let listStyle = (listData.style === '') || (listData.style === undefined) || (listData.style === null) ? 'pulse' : listData.style;
    const droplistData = {
      isUser: false,
      type: 'droplist',
      info: text,
      style: listStyle,
      title: listData.title,
      options: listData.options
    };
    this.buildResponse(droplistData, delayFlag);
  }

  commentForm1Template(decisionMaker, delayFlag) {
    const comment = decisionMaker.form_comment;
    let fields: any = {
      comment: null
    };
    if ((comment.fields !== undefined) && (comment.fields !== null)) {
      comment.fields.forEach(field => {
        if (field.type === 'hidden') {
          fields[field.name] = field.value;
        }
      });
    }
    let formStyle = (decisionMaker.style === '') || (decisionMaker.style === undefined) || (decisionMaker.style === null) ? 'pulse' : decisionMaker.style;
    const commentData = {
      isUser: false,
      type: 'commentForm1',
      style: formStyle,
      formFields: fields,
      title: comment.title,
      icon: comment.icon,
      url: comment.url
    };
    this.buildResponse(commentData, delayFlag);
  }

  commentForm2Template(decisionMaker, delayFlag) {
    const comment = decisionMaker.form_comment;
    let fields: any = {
      comment: null,
      name: null
    };
    if ((comment.fields !== undefined) && (comment.fields !== null)) {
      comment.fields.forEach(field => {
        if (field.type === 'hidden') {
          fields[field.name] = field.value;
        }
      });
    }
    let formStyle = (decisionMaker.style === '') || (decisionMaker.style === undefined) || (decisionMaker.style === null) ? 'pulse' : decisionMaker.style;
    const commentData = {
      isUser: false,
      type: 'commentForm2',
      style: formStyle,
      formFields: fields,
      title: comment.title,
      icon: comment.icon,
      url: comment.url
    };
    this.buildResponse(commentData, delayFlag);
  }

  commentForm3Template(decisionMaker, delayFlag) {
    const comment = decisionMaker.form_comment;
    let fields: any = {
      comment: null,
      name: null,
      email: null
    };
    if ((comment.fields !== undefined) && (comment.fields !== null)) {
      comment.fields.forEach(field => {
        if (field.type === 'hidden') {
          fields[field.name] = field.value;
        }
      });
    }
    let formStyle = (decisionMaker.style === '') || (decisionMaker.style === undefined) || (decisionMaker.style === null) ? 'pulse' : decisionMaker.style;
    const commentData = {
      isUser: false,
      type: 'commentForm3',
      style: formStyle,
      formFields: fields,
      title: comment.title,
      icon: comment.icon,
      url: comment.url
    };
    this.buildResponse(commentData, delayFlag);
  }

  commentForm4Template(decisionMaker, delayFlag) {
    const comment = decisionMaker.form_comment;
    let fields: any = {
      comment: null,
      name: null,
      mobile: null
    };
    if ((comment.fields !== undefined) && (comment.fields !== null)) {
      comment.fields.forEach(field => {
        if (field.type === 'hidden') {
          fields[field.name] = field.value;
        }
      });
    }
    let formStyle = (decisionMaker.style === '') || (decisionMaker.style === undefined) || (decisionMaker.style === null) ? 'pulse' : decisionMaker.style;
    const commentData = {
      isUser: false,
      type: 'commentForm4',
      style: formStyle,
      formFields: fields,
      title: comment.title,
      icon: comment.icon,
      url: comment.url
    };
    this.buildResponse(commentData, delayFlag);
  }

  commentForm5Template(decisionMaker, delayFlag) {
    const comment = decisionMaker.form_comment;
    let fields: any = {
      comment: null,
      name: null,
      email: null,
      mobile: null
    };
    if ((comment.fields !== undefined) && (comment.fields !== null)) {
      comment.fields.forEach(field => {
        if (field.type === 'hidden') {
          fields[field.name] = field.value;
        }
      });
    }
    let formStyle = (decisionMaker.style === '') || (decisionMaker.style === undefined) || (decisionMaker.style === null) ? 'pulse' : decisionMaker.style;
    const commentData = {
      isUser: false,
      type: 'commentForm5',
      style: formStyle,
      formFields: fields,
      title: comment.title,
      icon: comment.icon,
      url: comment.url
    };
    this.buildResponse(commentData, delayFlag);
  }

  loginTemplate(decisionMaker, delayFlag) {
    const logData = decisionMaker.form_login;
    let fields: any = {
      username: null,
      password: null
    };
    if ((logData.fields !== undefined) && (logData.fields !== null)) {
      logData.fields.forEach(field => {
        if (field.type === 'hidden') {
          fields[field.name] = field.value;
        }
      });
    }
    let formStyle = (decisionMaker.style === '') || (decisionMaker.style === undefined) || (decisionMaker.style === null) ? 'pulse' : decisionMaker.style;
    const temp = {
      isUser: false,
      type: 'loginForm',
      style: formStyle,
      formFields: fields,
      title: logData.title,
      icon: logData.icon,
      url: logData.url
    };
    console.log('OK', fields, decisionMaker, temp);
    this.buildResponse(temp, delayFlag);
  }

  subscriptionTemplate(decisionMaker, delayFlag) {
    const subscription = decisionMaker.form_subscription;
    let fields: any = {
      email: null
    };
    if ((subscription.fields !== undefined) && (subscription.fields !== null)) {
      subscription.fields.forEach(field => {
        if (field.type === 'hidden') {
          fields[field.name] = field.value;
        }
      });
    }
    let formStyle = (decisionMaker.style === '') || (decisionMaker.style === undefined) || (decisionMaker.style === null) ? 'pulse' : decisionMaker.style;
    const temp = {
      isUser: false,
      type: 'subscriptionForm',
      style: formStyle,
      formFields: fields,
      title: subscription.title,
      icon: subscription.icon,
      url: subscription.url
    };
    console.log('OK', fields, decisionMaker, temp);
    this.buildResponse(temp, delayFlag);
  }

  buildResponse(reply, delayFlag) {
    if (delayFlag) {
      this.chats.push(reply);
    } else {
      this.chats.push(reply);
      this.scrollDown();
    }
  }

  scrollDown() {
    setTimeout(() => {
      if ((this.scrollRef !== undefined) && (this.scrollRef !== null)) {
        if ((this.scrollRef.nativeElement !== undefined) && (this.scrollRef.nativeElement !== null)) {
          this.scrolltop = this.scrollRef.nativeElement.scrollHeight;
        }
      }
    }, 200);
  }

  setPersistentMenu(menu) {
    if ((menu !== undefined) && (menu !== null) && (menu.length)) {
      this.persistantMenus = menu;
    }
  }

  toggleEmojis() {
    this.emojiFlag = !(this.emojiFlag);
  }

  addEmoji(event) {
    if (event.emoji && event.emoji.id) {
      if ((this.message === null) || (this.message === '')) {
        this.message = `:${event.emoji.id}:`;
      } else {
        this.message = this.message + `:${event.emoji.id}:`;
      }
    }
    this.emojiFlag = false;
    this.input.nativeElement.focus();
  }

  ratingChanged(rateData) {
    if ((rateData !== undefined) && (rateData !== null)) {
      const query = `rating_${rateData.id}_${rateData.value}star`;
      this.getResponse(query, false);
    }
  }

  thumbsClicked(rateData, btnTp) {
    if ((rateData !== undefined) && (rateData !== null)) {
      let query = '';
      if (btnTp === 'like') {
        query = `rating_${rateData.id}_5thumb`;
        this.color1 = '#333';
        this.color2 = '#95A5A6';
      } else {
        query = `rating_${rateData.id}_0thumb`;
        this.color2 = '#333';
        this.color1 = '#95A5A6';
      }
      console.log('Ok', rateData, query);
      this.getResponse(query, false);
    }
  }

  submitComment(commentForm: NgForm, chat) {
    if (commentForm.valid) {
      this.hideCommentFormIfExists();
      this.appService.comment(chat.url, chat.formFields).subscribe(res => {
        console.log('commentRes', res);
        this.responseAnalyser(res, false);
      }, error => {
        console.log('commentErr', error);
      });
    }
  }

  hideCommentFormIfExists() {
    const lastEl = this.chats.length - 1;
    if (this.chats[lastEl].type.includes('Form')) {
      this.chats.splice(lastEl, 1);
    }
  }

  uploadFiles(event) {
    if (event.target.files.length > 0) {
      this.emojiFlag = false;
      this.removeRatingIfExists();
      this.removeButtonsIfExists();
      this.disableDropdownIfExists(this.chats.length - 1);
      const fileData = {
        attachment: event.target.files[0],
        key: this.uploadKey,
        user: this.userID
      };

      console.log('OK Done', fileData);
      this.appService.uploadFiles(fileData).subscribe(res => {
        console.log('uploadRes', res);
        const responseText = res;
        if (res.success === true) {
          this.chats.push({
            isUser: true,
            path: environment.uploadBaseUrl + responseText.data.url,
            info: responseText.data.name,
            type: 'attachment',
            text: null
          });
        }

        const data = 'some text';
        const blob = new Blob([this.chats[this.chats.length - 1].path], { type: 'application/octet-stream' });

        this.chats[this.chats.length - 1].path = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
      }, error => {
        console.log('uploadError', error);
      });
    }
  }

  changeFontsize(fontsize) {
    console.log(fontsize)
    switch (fontsize) {
      case 'small':
        this.fontsizeClass = 'small-txt';
        // this.fontsizeClass2 = 'small-txt2';
        break;
      case 'medium':
        this.fontsizeClass = 'medium-txt';
        // this.fontsizeClass2 = 'medium-txt2';
        break;
      case 'large':
        this.fontsizeClass = 'large-txt';
        // this.fontsizeClass2 = 'large-txt2';
        break;
    }
  }

}

